import {
  BENEFITCARD_LOADING,
  BENEFITCARD_SUCCESS,
  BENEFITCARD_FAILED,

  STAFF_BENEFITCARD_LOADING,
  STAFF_BENEFITCARD_SUCCESS,
  STAFF_BENEFITCARD_FAILED,

  STAFF_BACK_BENEFITCARD_LOADING,
  STAFF_BACK_BENEFITCARD_SUCCESS,
  STAFF_BACK_BENEFITCARD_FAILED
} from '../actions/benefitCardActions'

const BenefitCard = (state = {}, action) => {
  switch (action.type) {
    case BENEFITCARD_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        benefitCard: {},
        error: null
      })
    case BENEFITCARD_SUCCESS:
      window.localStorage.setItem('benefitCardData', JSON.stringify(action.response))
      return Object.assign({}, state, {
        benefitCard: action.response,
        error: null,
        isLoading: false
      })
    case BENEFITCARD_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        benefitCard: {},
        isLoading: false
      })
    // staff benefit card
    case STAFF_BENEFITCARD_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        staffBenefitCard: {},
        error: null
      })
    case STAFF_BENEFITCARD_SUCCESS:
      window.localStorage.setItem('benefitCard', JSON.stringify(action.response))
      return Object.assign({}, state, {
        staffBenefitCard: action.response,
        error: null,
        isLoading: false
      })
    case STAFF_BENEFITCARD_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        staffBenefitCard: {},
        isLoading: false
      })
      // staff benefit card back
    case STAFF_BACK_BENEFITCARD_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        staffBenefitCardBack: {},
        error: null
      })
    case STAFF_BACK_BENEFITCARD_SUCCESS:
      window.localStorage.setItem('benefitCardBack', JSON.stringify(action.response))
      return Object.assign({}, state, {
        staffBenefitCardBack: action.response,
        error: null,
        isLoading: false
      })
    case STAFF_BACK_BENEFITCARD_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        staffBenefitCardBack: {},
        isLoading: false
      })

    default:
      return state
  }
}
export default BenefitCard



// WEBPACK FOOTER //
// ./src/redux/reducers/benefitCardReducer.js